"use strict";
/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMediaExtended__factory = void 0;

var ethers_1 = require("ethers");

var IMediaExtended__factory = /*#__PURE__*/function () {
  function IMediaExtended__factory() {
    _classCallCheck(this, IMediaExtended__factory);
  }

  _createClass(IMediaExtended__factory, null, [{
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
  }]);

  return IMediaExtended__factory;
}();

exports.IMediaExtended__factory = IMediaExtended__factory;
var _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    internalType: "string",
    name: "_uri",
    type: "string"
  }],
  name: "TokenMetadataURIUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    internalType: "string",
    name: "_uri",
    type: "string"
  }],
  name: "TokenURIUpdated",
  type: "event"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    components: [{
      internalType: "uint256",
      name: "amount",
      type: "uint256"
    }, {
      internalType: "address",
      name: "currency",
      type: "address"
    }, {
      internalType: "address",
      name: "bidder",
      type: "address"
    }, {
      internalType: "address",
      name: "recipient",
      type: "address"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "sellOnShare",
      type: "tuple"
    }],
    internalType: "struct IMarket.Bid",
    name: "bid",
    type: "tuple"
  }],
  name: "acceptBid",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "recipient",
    type: "address"
  }],
  name: "auctionTransfer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "marketContract",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "string",
      name: "tokenURI",
      type: "string"
    }, {
      internalType: "string",
      name: "metadataURI",
      type: "string"
    }, {
      internalType: "bytes32",
      name: "contentHash",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "metadataHash",
      type: "bytes32"
    }],
    internalType: "struct IMedia.MediaData",
    name: "data",
    type: "tuple"
  }, {
    components: [{
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "prevOwner",
      type: "tuple"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "creator",
      type: "tuple"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "owner",
      type: "tuple"
    }],
    internalType: "struct IMarket.BidShares",
    name: "bidShares",
    type: "tuple"
  }],
  name: "mint",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "creator",
    type: "address"
  }, {
    components: [{
      internalType: "string",
      name: "tokenURI",
      type: "string"
    }, {
      internalType: "string",
      name: "metadataURI",
      type: "string"
    }, {
      internalType: "bytes32",
      name: "contentHash",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "metadataHash",
      type: "bytes32"
    }],
    internalType: "struct IMedia.MediaData",
    name: "data",
    type: "tuple"
  }, {
    components: [{
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "prevOwner",
      type: "tuple"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "creator",
      type: "tuple"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "owner",
      type: "tuple"
    }],
    internalType: "struct IMarket.BidShares",
    name: "bidShares",
    type: "tuple"
  }, {
    components: [{
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }, {
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }],
    internalType: "struct IMedia.EIP712Signature",
    name: "sig",
    type: "tuple"
  }],
  name: "mintWithSig",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    components: [{
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }, {
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }],
    internalType: "struct IMedia.EIP712Signature",
    name: "sig",
    type: "tuple"
  }],
  name: "permit",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "removeAsk",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "removeBid",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "revokeApproval",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    components: [{
      internalType: "uint256",
      name: "amount",
      type: "uint256"
    }, {
      internalType: "address",
      name: "currency",
      type: "address"
    }],
    internalType: "struct IMarket.Ask",
    name: "ask",
    type: "tuple"
  }],
  name: "setAsk",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    components: [{
      internalType: "uint256",
      name: "amount",
      type: "uint256"
    }, {
      internalType: "address",
      name: "currency",
      type: "address"
    }, {
      internalType: "address",
      name: "bidder",
      type: "address"
    }, {
      internalType: "address",
      name: "recipient",
      type: "address"
    }, {
      components: [{
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }],
      internalType: "struct Decimal.D256",
      name: "sellOnShare",
      type: "tuple"
    }],
    internalType: "struct IMarket.Bid",
    name: "bid",
    type: "tuple"
  }],
  name: "setBid",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenMetadataURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "string",
    name: "metadataURI",
    type: "string"
  }],
  name: "updateTokenMetadataURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "string",
    name: "tokenURI",
    type: "string"
  }],
  name: "updateTokenURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];